'use client'
import React, {
  PropsWithChildren,
  useCallback,
  useLayoutEffect,
  useState,
} from 'react'

import { useTranslations } from 'next-intl'
import { LoadingWithContainer } from '../../Loaders'
import LoadMoreButton from '../../LoadMoreButton/loadMoreButton'
import { Body, Cell, Head, NoData, Row, Table } from '../Elements'
import styles from '../Elements/styles.module.scss'
import { IDataTable } from './types'
import { useBody } from './useBody'

interface DataTableProps {
  itemsInPage?: number
  data: IDataTable
  loading?: boolean
  loadMoreClick: () => void
  totalCount?: number
}
const TableDataWithPagination: React.FC<DataTableProps> = ({
  itemsInPage = 20,
  data,
  loading,
  loadMoreClick,
  totalCount,
}: PropsWithChildren<DataTableProps>) => {
  const t = useTranslations('translation')

  const body = useBody({
    columns: data.columns,
    rows: data.rows,
  })

  return (
    <div>
      {data.rows.length === 0 ? (
        <NoData>{t('noData')}</NoData>
      ) : (
        <Table>
          <Head>
            <Row>
              {data.columns.map(column => (
                <Cell key={column.field}>{column.label}</Cell>
              ))}
            </Row>
          </Head>
          <Body>{body}</Body>
        </Table>
      )}

      {!!totalCount && totalCount > itemsInPage ? (
        <div className={styles.loadMoreWrap}>
          <LoadMoreButton onClick={loadMoreClick} loading={loading}>
            {t('loadMore')}
          </LoadMoreButton>
        </div>
      ) : null}
    </div>
  )
}

export default TableDataWithPagination
